// packages/web/src/components/SignOutButton.tsx — ported 2026-07-29 from the
// Rexx fork (found there 2026-07-21: no sign-out path existed anywhere in
// the app — the same gap exists here, unfixed until now). Best-effort:
// /auth/logout tolerates an already-gone session (server clears the cookie
// either way), and the reload afterward is what actually matters — it forces
// a fresh boot() cycle that re-checks whoami() properly, which a
// client-side-only state reset would not.
import { useState } from 'preact/hooks';
import { logout } from '../lib/api';
import { clearStoredTenantId } from '../lib/tenant';
import './SignOutButton.css';

export function SignOutButton() {
  const [busy, setBusy] = useState(false);

  async function signOut() {
    setBusy(true);
    try {
      await logout();
    } catch {
      // Ignore — we're leaving either way; see header note.
    }
    clearStoredTenantId();
    window.location.href = '/';
  }

  return (
    <button type="button" class="signout-button" disabled={busy} onClick={() => void signOut()}>
      {busy ? 'Signing out…' : 'Sign out'}
    </button>
  );
}
